const expireTime = role => {
  if (!role) { return 30 }
  switch (role.toLowerCase()) {
    case 'donor':
      return 10
    case 'manager':
      return 30
    case 'staff':
      return 30
    case 'sysadmin':
      return 30

    default:
      return 30
  }
}
export default expireTime
